<div class="page page-backups">
  <div class="container">
    <h2>Gerenciamento de Backups</h2>
    <p>Veja aqui todos os backups disponíveis para sua conta Assine Online</p>

    <div class="form-row">
      <div class="col-md-6 mb-3">        
      </div>

      <div class="col-md-6 mb-3 d-flex justify-content-end align-items-center">
        <!-- Clear Completed Downloads -->
        <button
          *ngIf="backupService.getDownloadStats().completed > 0"
          type="button"
          class="btn btn-sm btn-outline-secondary mr-2"
          (click)="clearCompletedDownloads()"
          title="Clear completed downloads from view">
          <i class="fa fa-broom"></i> Limpar Downloads Concluídos
        </button>

        <!-- Request Backup Button -->
        <button
          type="button"
          class="btn btn-sm btn-secondary"
          (click)="openModal()">
          <i class="fa fa-plus-circle"></i> Solicitar Backup
        </button>
        &nbsp;
        <a
          class="btn btn-sm btn-secondary" 
          href="/manager/manage-backups">
          <i class="fa fa-sync"></i> Atualizar página
        </a>
      </div>
    </div>

    <!-- Backups Table -->
    <div class="table-container">
      <!-- Empty State -->
      <div *ngIf="backups.length === 0" class="text-center mt-5 mb-5">
        <div class="empty-state">
          <i class="fa fa-database fa-3x text-muted mb-3"></i>
          <h4 class="text-muted">Nenhum backup foi encontrado</h4>
          <p class="text-muted">Nenhum backup foi criado ainda. Clique em "Solicitar Backup" para criar seu primeiro backup.</p> 
        </div>
      </div>

      <!-- Backups Table -->
      <div *ngIf="backups.length > 0" class="table-responsive">
        <table class="table table-striped table-hover">
          <thead class="thead-light">
            <tr>
              <th width="40%">
                <i class="fa fa-info-circle"></i> Informações do Backup
              </th>
              <th width="20%">
                <i class="fa fa-flag"></i> Status
              </th>
              <th width="40%">
                <i class="fa fa-cogs"></i> Ações
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let backup of backups; let i = index; trackBy: trackById" 
                [class.table-active]="isDownloadActive(backup.id)">
              
              <!-- Backup Information Column -->
              <td class="backup-info">
                <div class="backup-id">
                  <strong class="text-primary">#{{ backup.id }}</strong>
                  <span *ngIf="backup.file_size" class="badge badge-info ml-2">
                    {{ getBackupFileSize(backup) }}
                  </span>
                </div>
                
                <div class="backup-dates mt-2">
                  <small class="text-muted">
                    <div><strong>Criado em:</strong> {{ backup.created_at | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
                    <div *ngIf="backup.started_at">
                      <strong>Iniciado em:</strong> {{ backup.started_at | date: 'dd/MM/yyyy HH:mm:ss' }}
                    </div>
                    <div *ngIf="backup.ended_at">
                      <strong>Finalizado em:</strong> {{ backup.ended_at | date: 'dd/MM/yyyy HH:mm:ss' }}
                    </div>
                    <div *ngIf="backup.downloaded_at">
                      <strong>Último download:</strong> {{ backup.downloaded_at | date: 'dd/MM/yyyy HH:mm:ss' }}
                    </div>
                    <div *ngIf="backup.deleted_at" class="text-danger">
                      <strong>Expirado em:</strong> {{ backup.deleted_at | date: 'dd/MM/yyyy HH:mm:ss' }}
                    </div>
                  </small>
                </div>

                <!-- Error Message Display -->
                <div *ngIf="backup.error_message" class="alert alert-danger alert-sm mt-2">
                  <i class="fa fa-exclamation-triangle"></i>
                  <strong>Error:</strong> {{ backup.error_message }}
                </div>
              </td>

              <!-- Status Column -->
              <td class="backup-status">
                <div class="status-indicator d-flex align-items-center">
                  <i [class]="translateStatus(backup.status).icon" 
                     [ngClass]="translateStatus(backup.status).color"></i>
                  <span [title]="translateStatus(backup.status).title" [ngClass]="translateStatus(backup.status).color" class="ml-2">
                    {{ translateStatus(backup.status).label }}
                  </span>
                </div>

                <!-- Download Status Indicator -->
                <div *ngIf="getDownloadState(backup.id).status !== 'idle'" class="download-status-badge mt-2">
                  <span class="badge"
                        [ngClass]="{
                          'badge-info': getDownloadState(backup.id).status === 'downloading',
                          'badge-warning': getDownloadState(backup.id).status === 'paused',
                          'badge-danger': getDownloadState(backup.id).status === 'error',
                          'badge-success': getDownloadState(backup.id).status === 'completed'
                        }">
                    <i class="fa fa-download"></i>
                    {{ getDownloadState(backup.id).status | titlecase }}
                  </span>
                </div>
              </td>

              <!-- Actions Column -->
              <td class="backup-actions">
                <!-- Download Section -->
                <div class="download-section">
                  <!-- Download Button -->
                  <button
                    *ngIf="canDownload(backup)"
                    [class]="getDownloadButtonClass(backup)"
                    [disabled]="isDownloadActive(backup.id)"
                    (click)="downloadFileOnNewLink($event, backup)"
                    [title]="getDownloadButtonText(backup)">
                    <i [class]="getDownloadButtonIcon(backup)"></i>
                    {{ getDownloadButtonText(backup) }}
                  </button> 
                  
                  <!-- Old Download Button
                  <button
                    *ngIf="canDownload(backup)"
                    [class]="getDownloadButtonClass(backup)"
                    [disabled]="isDownloadActive(backup.id)"
                    (click)="downloadFile($event, backup)"
                    [title]="getDownloadButtonText(backup)">
                    <i [class]="getDownloadButtonIcon(backup)"></i>
                    {{ getDownloadButtonText(backup) }}
                  </button>
                  -->

                  <!-- Disabled Download Button -->
                  <button
                    *ngIf="!canDownload(backup)"
                    class="btn btn-sm btn-secondary disabled"
                    disabled
                    title="Download not available">
                    <i class="fa fa-download"></i>
                    Download indisponível
                  </button>

                  <!-- Download Controls -->
                  <div *ngIf="isDownloadActive(backup.id)" class="download-controls mt-2">
                    <button 
                      class="btn btn-xs btn-warning mr-1"
                      (click)="pauseDownload($event, backup.id)"
                      title="Pause download">
                      <i class="fa fa-pause"></i>
                    </button>
                    <button 
                      class="btn btn-xs btn-danger"
                      (click)="cancelDownload($event, backup.id)"
                      title="Cancel download">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>

                  <!-- Resume Button -->
                  <div *ngIf="canResumeDownload(backup.id)" class="resume-section mt-2">
                    <button 
                      class="btn btn-sm btn-success"
                      (click)="resumeDownload($event, backup)"
                      title="Resume download from {{ formatBytes(getDownloadState(backup.id).downloadedBytes) }}">
                      <i class="fa fa-play"></i>
                      Retormar ({{ formatBytes(getDownloadState(backup.id).downloadedBytes) }})
                    </button>
                  </div>
                </div>

                <!-- Download Progress Section -->
                <div *ngIf="getDownloadState(backup.id).status === 'downloading' || 
                            getDownloadState(backup.id).status === 'paused'" 
                     class="progress-section mt-3">
                  
                  <!-- Progress Bar -->
                  <div class="progress progress-sm">
                    <div class="progress-bar" 
                         [ngClass]="getProgressBarColor(backup.id)"
                         [style.width.%]="getDownloadState(backup.id).progress"
                         role="progressbar">
                    </div>
                  </div>

                  <!-- Progress Details -->
                  <div class="progress-details d-flex justify-content-between align-items-center mt-1">
                    <small class="text-muted">
                      {{ getDownloadState(backup.id).progress }}% completo
                    </small>
                    <small class="text-muted" *ngIf="getDownloadState(backup.id).totalBytes > 0">
                      {{ formatBytes(getDownloadState(backup.id).downloadedBytes) }} /
                      {{ formatBytes(getDownloadState(backup.id).totalBytes) }}
                    </small>
                  </div>

                  <!-- Download Speed and ETA -->
                  <div *ngIf="getDownloadState(backup.id).status === 'downloading'" 
                       class="download-stats d-flex justify-content-between align-items-center mt-1">
                    <small class="text-info" *ngIf="getDownloadState(backup.id).downloadSpeed">
                      <i class="fa fa-tachometer-alt"></i>
                      {{ formatDownloadSpeed(getDownloadState(backup.id).downloadSpeed!) }}
                    </small>
                    <small class="text-info" *ngIf="getDownloadState(backup.id).estimatedTimeRemaining">
                      <i class="fa fa-clock"></i>
                      {{ formatTimeRemaining(getDownloadState(backup.id).estimatedTimeRemaining!) }} restante
                    </small>
                  </div>
                </div>

                <!-- Error Display -->
                <div *ngIf="getDownloadState(backup.id).status === 'error'" 
                     class="error-section mt-3">
                  <div class="alert alert-danger alert-sm d-flex justify-content-between align-items-center">
                    <div>
                      <small>
                        <i class="fa fa-exclamation-triangle"></i>
                        {{ getDownloadState(backup.id).error }}
                      </small>
                    </div>
                    <button class="btn btn-xs btn-warning"
                            (click)="resumeDownload($event, backup)"
                            title="Retry download">
                      <i class="fa fa-retry"></i> Reiniciar Download
                    </button>
                  </div>
                </div>

                <!-- Server Actions -->
                <div class="server-actions mt-3">
                  <button
                    *ngIf="backup.status === 'failed'"
                    class="btn btn-sm btn-warning"
                    (click)="retryBackup(backup.id)"
                    title="Retry backup creation on server">
                    <i class="fa fa-redo"></i> Reiniciar Backup
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    
    <!-- Pagination -->
    <div class="mt-4 d-flex justify-content-center" *ngIf="totalBackups > pageSize">
      <ngb-pagination
        [collectionSize]="totalBackups"
        [(page)]="currentPage"
        [pageSize]="pageSize"
        [maxSize]="5"
        [rotate]="true"
        [boundaryLinks]="true"
        (pageChange)="loadBackups()">
      </ngb-pagination>
    </div>
  </div>

  <!-- Create Backup Modal -->
  <ng-template #modalCreateBackup let-modal>
    <app-modal-action
      [modal]="modal"
      [typeModal]="'simple green'"
      [showHeader]="true"
      [showFooter]="false"
      [showClose]="false"
      [title]="'Solicitar Backup'">
      
      <form [formGroup]="backupForm">
        <!-- Full Backup Checkbox -->
        <div class="mb-3">
          <div class="form-check">
            <input
              id="fullBackup"
              type="checkbox"
              class="form-check-input"
              formControlName="fullBackup"
              (change)="toggleDateFields()" />
            <label for="fullBackup" class="form-check-label">
              <strong>Backup Completo</strong>
              <small class="text-muted d-block">
                Criar um backup completo de todos os dados (ignora intervalo de datas)
              </small>
            </label>
          </div>
        </div>

        <!-- Date Range Section -->
        <div class="date-range-section" 
             [class.disabled-section]="backupForm.get('fullBackup')?.value">
          
          <!-- Start Date -->
          <div class="mb-3">
            <label for="startDate" class="form-label">
              <strong>Data de Início</strong>
              <small class="text-muted">*Obrigatório para backup parcial</small>
            </label>
            <input
              id="startDate"
              type="date"
              class="form-control"
              formControlName="startDate"
              [min]="minStartDate"
              [max]="currentDate"
              [class.is-invalid]="backupForm.get('startDate')?.invalid && backupForm.get('startDate')?.touched" />
            <div class="invalid-feedback" 
                 *ngIf="backupForm.get('startDate')?.invalid && backupForm.get('startDate')?.touched">
              Por favor, selecione uma data de início válida.
            </div>
          </div>

          <!-- End Date -->
          <div class="mb-3">
            <label for="endDate" class="form-label">
              <strong>Data de Fim</strong>
              <small class="text-muted">*Obrigatório para backup parcial</small>
            </label>
            <input
              id="endDate"
              type="date"
              class="form-control"
              formControlName="endDate"
              [min]="backupForm.get('startDate')?.value || minStartDate"
              [max]="currentDate"
              [class.is-invalid]="backupForm.get('endDate')?.invalid && backupForm.get('endDate')?.touched" />
            <div class="invalid-feedback" 
                 *ngIf="backupForm.get('endDate')?.invalid && backupForm.get('endDate')?.touched">
              Por favor, selecione uma data de fim válida.
            </div>
          </div>
        </div>

        <!-- Help Text -->
        <div class="alert alert-info" role="alert">
          <i class="fa fa-info-circle"></i>
          <strong>Atenção:</strong> O processamento do backup pode demorar alguns minutos ou horas, dependendo do volume de dados.
          O arquivo de backup estará disponível para download após a conclusão do processamento.
        </div>

        <!-- Modal Actions -->
        <div class="modal-actions text-center mt-4">
          <button
            type="button"
            class="btn btn-danger btn-sm mr-3"
            (click)="modal.close('cancel')">
            <i class="fa fa-times"></i> Cancelar
          </button>
          <button
            type="button"
            class="btn btn-primary btn-sm"
            [disabled]="backupForm.invalid"
            (click)="requestBackup()">
            <i class="fa fa-check"></i> Solicitar Backup
          </button>
        </div>
      </form>
    </app-modal-action>
  </ng-template>
</div>